import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';

// Dialog
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

// input
import TextField from '@mui/material/TextField';


// service
import DonationService from "../services/DonationService";


const AddDonation = props => {
    const initialDonationState = {
        id: null,
        data_accredito: "",
        importo: "",
        metodo: "",
        tipologia: "",
        campagna: "",
        progetto: "",
        ringraziamento: "",
        ricevuta: "",
        donatore_id: ""
    }

    const [Donation, setDonation] = useState(initialDonationState);


    const saveDonation = () => {
        var data = {
            id: Donation.id,
            data_accredito: Donation.data_accredito,
            importo: Donation.importo,
            metodo: Donation.metodo,
            tipologia: Donation.tipologia,
            campagna: Donation.campagna,
            progetto: Donation.progetto,
            ringraziamento: Donation.ringraziamento,
            ricevuta: Donation.ricevuta,
            donatore_id: Donation.donatore_id
        };

        DonationService.create(data)
            .then(response => {
                setDonation({
                    id: response.data.id,
                    data_accredito: response.data.data_accredito,
                    importo: response.data.importo,
                    metodo: response.data.metodo,
                    tipologia: response.data.tipologia,
                    campagna: response.data.campagna,
                    progetto: response.data.progetto,
                    ringraziamento: response.data.ringraziamento,
                    ricevuta: response.data.ricevuta,
                    donatore_id: response.data.donatore_id
                });
                console.log(response.data);
            })
            .catch(e => {
                console.log(e);
            });
    };

    //start Dialog

    function PaperComponent(props) {
        return (
            <Draggable
                handle="#draggable-dialog-title"
                cancel={'[class*="MuiDialogContent-root"]'}
            >
                <Paper {...props} />
            </Draggable>
        );
    }


    const [open, setOpen] = React.useState(false);

    const handleClickOpen = (e) => {
        setOpen(true);
        setDonation(e.row);
    };

    const handleClose = () => {
        setOpen(false);
    }

    //end Dialog

    const rows = props.donations;
    const { id } = useParams();
    let navigate = useNavigate();
    const info = (props.v) ? props.v : false;
    const addAction = (props.addAction) ? props.addAction : false;


    const [value, setValue] = React.useState(0);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setDonation({ ...Donation, [name]: value });
    };


    const [openDialog, setOpenDialog] = useState(false);

    const handleDialog = (e) => {
        setOpenDialog(true)

    }


    const deleteDonation = () => {
        DonationService.remove(Donation.id)
            .then(response => {
                console.log(response.data);
                navigate("/Donations");
            })
            .catch(e => {
                console.log(e);
            });
    };

    return (
        <>
            <div style={{ height: 600, width: '100%' }}>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    PaperComponent={PaperComponent}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                        Aggiungi donazione
                    </DialogTitle>
                    <DialogContent sx={{ marginTop: "10px" }}>
                        <TextField id="outlined-basic" label="Data accredito" name="data_accredito" type="date" variant="outlined" style={{ marginTop: "10px", marginBottom: "20px", marginRight: "20px" }} disabled={info} onChange={handleInputChange} />
                        <TextField id="outlined-basic" label="Importo" name="importo" variant="outlined" style={{ marginTop: "10px", marginBottom: "20px", marginRight: "20px" }} disabled={info} onChange={handleInputChange} />
                        <TextField id="outlined-basic" label="Metodo" name="metodo" variant="outlined" style={{ marginTop: "10px", marginBottom: "20px", marginRight: "20px" }} disabled={info} onChange={handleInputChange} />
                        <TextField id="outlined-basic" label="Tipologia" name="tipologia" variant="outlined" style={{ marginTop: "10px", marginBottom: "20px", marginRight: "20px" }} disabled={info} onChange={handleInputChange} />
                        <TextField id="outlined-basic" label="Campagna" name="campagna" variant="outlined" style={{ marginTop: "10px", marginBottom: "20px", marginRight: "20px" }} disabled={info} onChange={handleInputChange} />
                        <TextField id="outlined-basic" label="Progetto" name="progetto" variant="outlined" style={{ marginTop: "10px", marginBottom: "20px", marginRight: "20px" }} disabled={info} onChange={handleInputChange} />
                        <TextField id="outlined-basic" label="Ringraziamento" name="ringraziamento" variant="outlined" style={{ marginTop: "10px", marginBottom: "20px", marginRight: "20px" }} disabled={info} onChange={handleInputChange} />
                        <TextField id="outlined-basic" label="Ricevuta" name="ricevuta" variant="outlined" style={{ marginTop: "10px", marginBottom: "20px", marginRight: "20px" }} disabled={info} onChange={handleInputChange} />
                        <DialogContentText>
                            Per salvare clicca su "Aggiorna" altrimenti "Chiudi"
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={handleClose}>
                            Chiudi
                        </Button>
                        <Button onClick={saveDonation}>Salva</Button>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    );
};

export default AddDonation;